import { render, staticRenderFns } from "./AddTableWidget.vue?vue&type=template&id=2952bbd9"
import script from "./AddTableWidget.vue?vue&type=script&lang=js"
export * from "./AddTableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports